function resetVariables(attributeList) {
    attributeList.forEach(attribute => {
        if (attribute && attribute.setter) {
            attribute.setter(attribute.defaultValue || '');
        }

        if (attribute && attribute.setterDescription) {
            attribute.setterDescription('');
        }
    });
}

export default { resetVariables };
